export default __webpack_public_path__ + "static/media/BatterySmart.291213fe.svg";